<template>
  <span>
    <em v-if="!globalId" v-once>
      {{ $t("The freelancer doesn't exist") }}
    </em>
    <GhostComponent
      v-if="globalId"
      :global-id="globalId"
      component-name-when-active="ProfileInfoCard"
    >
      <a :href="profileUrl || '#'">
        <slot name="name">
          {{ name || $t('(No name)') }}
        </slot>
      </a>
    </GhostComponent>
    <div>
      <BaseLabel
        v-if="hasDraftContract"
        v-tooltip:top="$t('The freelancer has not accepted the contract yet')"
        :text="$t('Not accepted')"
        :uppercase="false"
        quiet
      />
    </div>
  </span>
</template>

<script>
import GhostComponent from '@/components/GhostComponent.vue'
import BaseLabel from '@/components/BaseLabel.vue'

export default {
  components: { BaseLabel, GhostComponent },
  props: {
    globalId: {
      type: String,
      default: '',
    },
    profileUrl: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    hasDraftContract: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped></style>
